import refs from '../refsLite'
import { serverTimestamp, setDoc } from 'firebase/firestore/lite'
import { nanoid } from 'nanoid'

export async function saveError3(
  exception = {
    message: 'Unknown error',
    stack: '',
  },
  context = {},
  source = null,
  domElement = null,
  column = null,
  line = null,
) {
  const id = +new Date() + nanoid()
  const { message, stack } = exception
  await setDoc(refs.error(id), {
    id,
    message: message || 'Unknown error',
    path: getElementHierarchy(domElement) || '',
    column: column || null,
    line: line || null,
    created: serverTimestamp(),
    stack: stack || '',
    source: JSON.parse(JSON.stringify(source?.toJson?.() || source || null)),
    context: JSON.parse(JSON.stringify(context || {})),
  })

  return id
}

function getElementHierarchy(domElement) {
  if (!domElement) return ''
  try {
    // this function creates a string of the hierarchy that a Vue element is in
    let s = domElement.$el.outerHTML
    let cur = domElement
    while (s?.length < 1000 && cur.$parent) {
      s += cur.$el.outerHTML + '\n'
      cur = cur.$parent
    }
    return s || ''
  } catch (ex) {
    console.warn('Unable to create element hierarchy: ', ex)
    return ''
  }
}
